import { useTranslation } from 'react-i18next';
import { ReviewStatus } from '../types/review';

interface ReviewStatusBadgeProps {
  readonly status: string; // string (not ReviewStatus) — tolerates unknown future statuses gracefully
}

// Record<ReviewStatus, string> enforces exhaustiveness at compile time — adding a new
// ReviewStatus value without updating these tables causes a TS error (Effective TypeScript §28).
const STATUS_STYLES: Record<ReviewStatus, string> = {
  pending:   'bg-amber-100 text-amber-700',
  published: 'bg-green-100 text-green-700',
  rejected:  'bg-red-100 text-red-700',
};

const KNOWN_STATUSES = Object.keys(STATUS_STYLES) as ReviewStatus[];

export const ReviewStatusBadge = ({ status }: ReviewStatusBadgeProps) => {
  const { t } = useTranslation('badges');

  const STATUS_LABELS: Record<ReviewStatus, string> = {
    pending:   t('statusPending'),
    published: t('statusPublished'),
    rejected:  t('statusRejected'),
  };

  const isKnown = KNOWN_STATUSES.includes(status as ReviewStatus);
  const classes = isKnown
    ? STATUS_STYLES[status as ReviewStatus]
    : 'bg-gray-100 text-gray-600';
  const label = isKnown
    ? STATUS_LABELS[status as ReviewStatus]
    : status;

  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${classes}`}>
      {label}
    </span>
  );
};
